import { MessageCircle } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router";

interface NavigationProps {
  onOpenChat: () => void;
}

const Navigation = ({ onOpenChat }: NavigationProps) => {
  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed top-0 left-0 right-0 z-50 glass-card"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <span className="font-serif text-xl font-bold tracking-tight text-foreground">
          TRH
        </span>

        <div className="flex items-center gap-8">
          <a href="#experience" className="text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
            Experience
          </a>
          <a href="#fit-check" className="text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
            Fit Check
          </a>
          <Link to="/how-its-built" className="text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
            How It's Built
          </Link>
          <button
            onClick={onOpenChat}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition-opacity glow-primary"
          >
            <MessageCircle size={16} />
            Ask AI
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
